import { User } from "@prisma/client";
import { Session } from "next-auth";

function isForceClient() {
  if (typeof window !== "undefined") {
    if (window.location.search.includes("client=1")) {
      return true;
    }
  }
  return false;
}

export function isDebug(user: User | null): boolean {
  if (typeof window !== "undefined") {
    if (isAdmin(user) && window.location.search.includes("debug=1")) {
      return true;
    }
  }
  return false;
}

export const isSelfService = (
  user: User | null,
  applicationUser?: User | null
): boolean => {
  if (applicationUser) {
    return Boolean(applicationUser?.isSelfServiceUser);
  }

  return Boolean(user?.isSelfServiceUser);
};

export const isAdmin = (user: User | null): boolean => {
  if (isForceClient()) {
    return false;
  }
  if (user === null) return false;
  return user.roleId === 2 || user.roleId === 3;
};

export const isSuperAdmin = (user: User | null): boolean => {
  if (isForceClient()) {
    return false;
  }
  if (user === null) return false;
  return user.roleId === 3;
};

export const isAuthorizedAsAdmin = (session: Session | null): boolean => {
  if (isForceClient()) {
    return false;
  }
  if (session === null) {
    return false;
  }

  if (
    (session.user as User).roleId === 2 ||
    (session.user as User).roleId === 3
  ) {
    return true;
  }

  return false;
};
